import React from 'react';
import { Container, ContainerButtons } from './styles';
import FormDefault from '~/components/FormDefault';

import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import Loja from '~/components/Loja';
import { useRelatorioRaioXVendas } from './RelatorioRaioXVendasContext';
import { InputDateRange, InputSelect } from '~/components/NovosInputs';
import AbaGeral from './Abas/AbaGeral';
import AbaFinalizadora from './Abas/AbaFinalizadora';
import AbaDepartamento from './Abas/AbaDepartamento';
import AbaTemporal from './Abas/AbaTemporal';
import AbaCaixa from './Abas/AbaCaixa';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { IoIosSearch } from 'react-icons/io';
import { FaEraser } from 'react-icons/fa';
import { MdOutlineCancel } from 'react-icons/md';
import { buscaDepartamento } from './types';

const RelatorioRaioXVendasContent: React.FC = () => {
  const {
    formRelatorioRaioXVendas: {
      control,
      register,
      setValue,
      formState: { errors },
    },
    keyRef,
    setDtaFiltro,
    dtaFiltro,
    handleSearch,
    handleResetForm,
    handleCancelForm,
    departamentos,
    setResetLoja,
    resetLoja,
    exib,
    loading,
    disabled,
    tab,
    handleChangeTab,
    buscaPorDepart,
    setBuscaPorDepart,
  } = useRelatorioRaioXVendas();

  const handleDataExecutar = (ini: string, fim: string, isInvalid: boolean) => {
    setDtaFiltro({
      ...dtaFiltro,
      dta_filtro_ini: {
        ...dtaFiltro.dta_filtro_ini,
        value: ini,
        isInvalid,
      },
      dta_filtro_fim: {
        ...dtaFiltro.dta_filtro_fim,
        value: fim,
        isInvalid,
      },
    });
  };

  return (
    <Container>
      <FormDefault
        codTela={308}
        title="Relatório Raio-X de Vendas"
        onSave={() => Promise.resolve()}
        onCancel={() => []}
        onClearFields={() => []}
        onNew={() => []}
        onDelete={() => []}
        onReturnSearch={() => []}
        isDelete={false}
        isClear={false}
        isSave
        isNew={false}
        isCancel={false}
      >
        <Row>
          <Col sm={12} md={12}>
            <Loja
              isMulti
              onChange={(val) => {
                setResetLoja(false);
                setValue('lojas', val);
              }}
              IsInvalid={false}
              resetLojas={resetLoja}
              disabled={disabled}
            />
          </Col>
          <Col sm={12} md={2}>
            <InputSelect
              label="Buscar Por"
              placeholder="Selecione o Departamento"
              name="busca_departamento"
              value={buscaPorDepart.label}
              register={register}
              isError={!!errors.busca_departamento}
              control={control}
              options={buscaDepartamento}
              disabled={disabled}
              changeSelected={(selected) => {
                setValue('cod_departamento', null);
                setBuscaPorDepart(selected);
              }}
            />
          </Col>
          <Col sm={12} md={6}>
            <InputSelect
              label="Departamento"
              placeholder="Selecione o Departamento"
              name="cod_departamento"
              register={register}
              isError={!!errors.cod_departamento}
              control={control}
              options={departamentos}
              disabled={disabled}
              changeSelected={(selected) => {
                setValue('cod_departamento', selected);
              }}
            />
          </Col>
          {/* md 6 caso NÃO tenha o buscapor * */}
          <Col sm={12} md={4}>
            <InputDateRange
              dataIni={dtaFiltro.dta_filtro_ini.value}
              dataFim={dtaFiltro.dta_filtro_fim.value}
              labelText="Intervalo"
              key={keyRef.current}
              timePicker={false}
              isRequired
              setInvalid={false}
              isDisabled={disabled}
              format="DD/MM/YYYY"
              onChange={(ini: string, fim: string, isInvalid = true) => {
                handleDataExecutar(ini, fim, isInvalid);
                setValue('dta_inicio', ini);
                setValue('dta_fim', fim);
              }}
            />
          </Col>
          <Col className="mt-2">
            <ContainerButtons>
              <CustomButtonNovo
                onClick={() => handleSearch()}
                label="Pesquisar"
                icon={IoIosSearch}
                disabled={disabled}
                showLoading={loading}
              />
              <CustomButtonNovo
                disabled={!disabled}
                onClick={handleCancelForm}
                label="Cancelar"
                icon={MdOutlineCancel}
                variant="cancel"
              />
              <CustomButtonNovo
                onClick={handleResetForm}
                disabled={disabled}
                label="Limpar"
                icon={FaEraser}
                variant="clear"
              />
            </ContainerButtons>
          </Col>
          {exib && (
            <Col sm={12} md={12} className="mt-2">
              <Tabs
                id="controlled-produto"
                activeKey={tab}
                onSelect={(k) => handleChangeTab(k)}
              >
                <Tab eventKey="geral" title="Resumo Geral">
                  <AbaGeral />
                </Tab>
                <Tab eventKey="departamento" title="Departamento">
                  <AbaDepartamento />
                </Tab>
                <Tab eventKey="finalizadora" title="Finalizadora">
                  <AbaFinalizadora />
                </Tab>
                <Tab eventKey="temporal" title="Temporal">
                  <AbaTemporal />
                </Tab>
                <Tab eventKey="caixa" title="Caixa">
                  <AbaCaixa />
                </Tab>
              </Tabs>
            </Col>
          )}
        </Row>
      </FormDefault>
    </Container>
  );
};

export default RelatorioRaioXVendasContent;
